import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {environment as envDEV} from './environments/environment.dev';
import {environment as envUAT} from './environments/environment.uat';
import {environment as envPROD} from './environments/environment.prod';
import {AppUrlHelper, EnvironmentHelper, ErrorInterceptorService} from 'amc-common-components';

EnvironmentHelper.setCurrentEnvironment(environment);
EnvironmentHelper.defineEnvironments({
	dev: envDEV,
	prod: envPROD,
	uat: envUAT,
});

AppUrlHelper.localErrorProcess();

ErrorInterceptorService.enableBugsnag({apiKey: 'e4a5a8175488e318e8e3a5a824833169'});

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch((err) => console.error(err));
